import { ArizonaActionType } from "./constants";

export const getDefaultState = () => ({
    chart: 'shortage_impacts_to_river_communities_vs_central_arizona',
});

export default (state = getDefaultState(), action) => {
    switch (action.type) {
        case ArizonaActionType.SET_CHART:
            return setChartSelection(state, action);
        default:
            return state;
    }
};

const setChartSelection = (state, { chart }) => {
    return {
        ...state,
        chart
    }
};